import { skipIfNull } from '@proscom/prostore';
import { useRetriableGraphql } from '../../../../common/useRetriableGraphqlVars';
import { QUERY_GET_DIRECTION_FPO_COMMENTS } from '../../../../graphql/queries/infralistComment';

const options = {
  query: QUERY_GET_DIRECTION_FPO_COMMENTS,
  mapData: (result) => result.infralistDirectionFpoCommentaries,
  skipQuery: skipIfNull(null)
};

export function useFetchDirectionFPOComments({ infralistId, directionId }) {
  const response = useRetriableGraphql({
    queryOptions: options,
    variables: {
      infralist_id: infralistId,
      direction_id: directionId
    },
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    }
  });
  const data = response.state.data;

  return data ?? [];
}
